import {
  Box,
  Button,
  Icon,
  Theme,
  Tooltip,
  Typography,
  useTheme
} from "@outschool/backpack";
import { faRefresh, faTimes } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import React from "react";

import { useChatContext } from "./chatProvider";

interface StyledActionButtonProps {
  onClick: () => void;
  disabled?: boolean;
  icon: any;
  text: string;
  tooltipTitle?: string | null;
}

function StyledActionButton({
  onClick,
  disabled = false,
  icon,
  text,
  tooltipTitle
}: StyledActionButtonProps) {
  const button = (
    <Button
      disabled={disabled}
      sx={(theme: Theme) => ({
        color: theme.palette.neutral[900],
        borderColor: theme.palette.neutral[300],
        padding: "1rem 2rem",
        gap: theme.spacing(6),
        "&.Mui-disabled": {
          color: theme.palette.neutral[500],
          backgroundColor: "common.white",
          border: `solid 2px ${theme.palette.neutral.light}`
        },
        width: "45%",
        [theme.breakpoints.down("md")]: {
          width: "100%",
          marginBottom: "1rem"
        }
      })}
      onClick={onClick}
    >
      <Icon icon={icon} />
      <Typography variant="body2" emphasized>
        {text}
      </Typography>
    </Button>
  );

  if (tooltipTitle) {
    return (
      <Tooltip placement="top" title={tooltipTitle}>
        <span>{button}</span>
      </Tooltip>
    );
  }

  return button;
}

export function ConciergeRequestCompleteButtons() {
  const { t } = useTranslation("client\\components\\chat");
  const { setIsModalOpen, resetConciergeRequest } = useChatContext();
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-around",
        gap: theme.spacing(2),
        [theme.breakpoints.down("md")]: {
          flexDirection: "column"
        }
      }}
    >
      <StyledActionButton
        onClick={resetConciergeRequest}
        icon={faRefresh}
        text={t("New Request")}
      />
      <StyledActionButton
        onClick={() => setIsModalOpen && setIsModalOpen(false)}
        icon={faTimes}
        text={t("Close")}
      />
    </Box>
  );
}
